export const init = () => {

    const fade_window_2_wrap_all = document.querySelectorAll(".js-fade-window-2-wrap");
    const fade_basic_all = document.querySelectorAll(".js-fade-window-basic");

    const close_fade_basic_all = function () {
        fade_basic_all.forEach(item => {
            item?.classList.remove('active');
            item.querySelector(".js-fade-window-basic_content")?.classList.remove("active");
        })
    };

    const close_fade_window_2_all = function () {
        fade_window_2_wrap_all.forEach(item => {
            item.querySelector(".js-fw2-title")?.classList.remove("js-rotate");
            item.querySelector('.js-fade-window-2')?.classList.remove('active');
        })
    };



    document.querySelector('body').addEventListener('click', function (e) {
        
        if (fade_window_2_wrap_all.length && !e.target.closest('.js-fade-window-2-wrap')) {  
            close_fade_window_2_all();        
        }
        if (fade_basic_all && !e.target.closest('.js-fade-window-basic')) {
            close_fade_basic_all();
        } 
    });


};
